import type { Locale } from '@/i18n/types';

/**
 * The name is settled: Mawqūt.
 *
 *   إِنَّ الصَّلَاةَ كَانَتْ عَلَى الْمُؤْمِنِينَ كِتَابًا مَوْقُوتًا
 *   — an-Nisā' 4:103
 *
 * `mawqūtā` is the Qur'an's own word for what this app is about: the prayer as
 * something written down at fixed times. Not a habit to build, not a score —
 * an appointment already made, which the app only helps a person keep.
 *
 * The mark is settled too: an astrolabe with its ring divided into five, in
 * Logo.tsx. The lantern that remains on the entry screen and in the reward is
 * a mascot, not the mark.
 *
 * Everything the name touches reads from here, and `brand.test.ts` fails if any
 * other source file hardcodes it — so renaming the app is this one file, the
 * mark in Logo.tsx, and the three places outside `src/` that a bundler or
 * Cloudflare owns: the page title in index.html, the manifest in
 * vite.config.ts, and the Worker name in wrangler.jsonc, which is what every
 * deployed hostname is built from.
 */
export const BRAND = {
  /** True while the name is still up for debate; it shows a notice on screen. */
  provisional: false,
  name: {
    en: 'Mawqut',
    ar: 'موقوت',
  } satisfies Record<Locale, string>,
} as const;

export function brandName(locale: Locale): string {
  return BRAND.name[locale];
}
